import type { DisplayFilterGroup, Session } from './types';
import { api } from '../utils/api';
import { makeAbortableRequest } from './request-handler.service';

interface DisplaySearchResult {
  query: string;
  nbOfPages: number;
  currentPage: number;
  nbOfTotalItems: number;
}

export interface FilterResponse {
  filterGroupsToShow: DisplayFilterGroup[];
  question: string;
  searchResult: DisplaySearchResult;
}

export const getSearchAiFilters = async ({
  searchId,
  usedFilters = '',
  session,
}: {
  searchId: string;
  usedFilters: string;
  session?: Session;
}): Promise<FilterResponse> => {
  const headers = {
    ...(session?.token ? { 'caddie-session-token': session.token } : {}),
  };

  return makeAbortableRequest<FilterResponse>(
    `getSearchAiFilters`,
    (signal) =>
      api
        .get(`chat/searches/${searchId}/filters?usedFilters=${usedFilters}`, {
          timeout: 200000,
          credentials: 'include',
          signal,
          headers,
        })
        .json<FilterResponse>(),
    100000
  );
};

export const getAiFiltersForPage = async ({
  currentPath,
  session,
}: {
  currentPath: string;
  session?: Session;
}): Promise<
  FilterResponse & {
    userQuery?: string;
    appliedFilters?: DisplayFilterGroup[];
  }
> => {
  const headers = {
    ...(session?.token ? { 'caddie-session-token': session.token } : {}),
  };

  return makeAbortableRequest<FilterResponse>(
    `getSearchAiFilters`,
    (signal) =>
      api
        .post(`chat/searches/pages/filters`, {
          timeout: 200000,
          credentials: 'include',
          signal,
          headers,
          json: { currentPath },
        })
        .json<FilterResponse>(),
    100000
  );
};
